import {Outlet, useLocation} from "react-router-dom";
import Surveys from '../../pages/Surveys/Surveys';
import Homepage from "../../pages/Home/Homepage";
import Login from "../../pages/Login/Login";
import React, {useContext} from "react";
import AppContext from "../components/AppContext";

const useAuth = () => {
    if (localStorage.getItem('tokenMKT') != null) {
        return {loggedIn: true};
    } else {
        return false;
    }
};

const ProtectedRoutes = () => {
    const isAuth = useAuth();
    const location = useLocation();
    const urlHome = location.pathname.split('/')[1] === "";
    const myContext = useContext(AppContext);
    const showLocation = () => {
        if (isAuth) {
            if (location.pathname.includes('/surveys/private')) {
                const idRespondentSurvey = window.location.pathname.split('/')[4];
                if (Number(myContext.user.SubjectId) !== Number(idRespondentSurvey)) {
                    return <Login />;
                }
            }
            if (urlHome) {
                return <Surveys/>;
            } else {
                return <Outlet/>;
            }
        } else {
            if (location.pathname.includes('/surveys/private') || location.pathname.includes('/Profile')) {
                return <Login />;
            }
            else {
                return <Homepage/>;
            }
        }
    }

    return showLocation();
}

export default ProtectedRoutes;